export class EncodingHelper {

  public static base64DecodeUnicode(str: string): string {
    return decodeURIComponent(atob(str).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
  }
}
